import { Column, Editing, Item, Lookup, RangeRule, RequiredRule, Toolbar } from 'devextreme-react/data-grid';
import React, { useEffect, useRef, useState } from 'react';
import { toast } from 'react-toastify';
import { Card, Button as RxButton } from 'reactstrap';
import Breadcrumb from '../../../components/common/breadcrumb';
import DatagridCustom from '../../../components/common/datagrid/custom-datagrid';
import api from '../../../services/api-configuration';
import { ButtonOnExporting } from '../../../utils/DataGridExporter';
import useFormatMessage from '../../../utils/useFormatMessage';

const AracModelleri = () => {
    const { t } = useFormatMessage();
    const [dataSources, setDataSources] = useState([]);
    const [brands, setBrands] = useState([]);
    let skipValidationCheck = false;
    const ref = useRef();
    const mountedRef = useRef(true);

    useEffect(() => {
        fetchBrands();
        fetchModels();

        return () => {
            mountedRef.current = false;
        };
        // eslint-disable-next-line
    }, []);


    const fetchBrands = async () => {
        try {
            const response = await api.post("/getAllBrands");
            if (mountedRef.current) { // Only update state if component is mounted
                setBrands(response.data.data || []);
            }
        } catch (error) {
            let errorMessage = error.response?.data?.error || "";
            toast.error(t('Markalar getirilirken hata oluştu') + ":" + errorMessage);
            console.error("Error fetching brands:", error);
        }
    };

    const fetchModels = async () => {
        try {
            ref.current.instance.beginCustomLoading();
            const response = await api.post("/getAllModels");
            if (mountedRef.current) { // Only update state if component is mounted
                setDataSources(response.data.data || []);
            }
        } catch (error) {
            let errorMessage = error.response?.data?.error || "";
            toast.error(t('Modeller getirilirken hata oluştu') + ":" + errorMessage);
            console.error("Error fetching models:", error);
        } finally {
            ref.current.instance.endCustomLoading();
        }
    };

    const addModel = async (newData, e) => {
        const employeeId = parseInt(Buffer.from(localStorage.getItem("employee_id"), 'base64').toString('ascii'));
        const body = { ...newData, is_active: true, create_user_id: employeeId };

        try {
            const response = await api.post("/createModel", body);
            if (response.status === 200 && mountedRef.current) {
                skipValidationCheck = true;
                e.component.saveEditData();
                fetchModels();
            }
        } catch (error) {
            let errorMessage = error.response?.data?.error || "";
            toast.error(t('Model eklenirken hata oluştu') + ":" + errorMessage);
            console.error("Error adding model:", error);
        }
    };

    const updateModel = async (data, e) => {
        const employeeId = parseInt(Buffer.from(localStorage.getItem("employee_id"), 'base64').toString('ascii'));
        const body = { ...data.oldData, ...data.newData, update_user_id: employeeId };

        try {
            const response = await api.post("/updateModel", body);
            if (response.status === 200 && mountedRef.current) {
                skipValidationCheck = true;
                e.component.saveEditData();
                fetchModels();
            }
        } catch (error) {
            let errorMessage = error.response?.data?.error || "";
            toast.error(t('Model güncellenirken hata oluştu') + ":" + errorMessage);
            console.error("Error updating model:", error);
        }
    };

    const onRowValidating = (e) => {
        if (e.brokenRules.length === 0) {
            if (skipValidationCheck) {
                e.isValid = true;
                skipValidationCheck = false;
                return;
            }

            e.isValid = false;
            if (!e.oldData) {
                addModel(e.newData, e);
            } else {
                updateModel(e, e);
            }
        }
    };

    const vehicleTypes = [
        { value: "PASSENGER", text: t("Binek") },
        { value: "COMMERCIAL", text: t("Ticari") },
        { value: "HEAVY_COMMERCIAL", text: t("Ağır Ticari") },
    ];

    // VehicleTypePassenger  VehicleType = "PASSENGER"
    // VehicleTypeCommercial VehicleType = "COMMERCIAL"
    // VehicleTypeHeavy      VehicleType = "HEAVY_COMMERCIAL"
    return (
        <>
            <Breadcrumb current={t("Model Tanımları")} />
            <Card className="p-4">
                <DatagridCustom
                    dataSource={dataSources}
                    onRowValidating={onRowValidating}
                    reff={ref}
                    onInitNewRow={(e) => {
                        e.data.is_active = true;
                        e.component.__addingStart = true;
                    }}
                >
                    <Editing
                        mode="popup"
                        popup={{
                            title: t("Model Ekle / Düzenle"),
                            showTitle: true,
                            width: 800,
                            height: 650,
                            position: { my: "center", at: "center", of: window },
                        }}
                        allowUpdating
                        allowAdding
                        useIcons
                    />
                    <Column
                        dataField="brand_id"
                        caption={t("Marka")}
                        alignment="center"
                        allowExporting={true}
                        // visible={false}
                        selectedFilterOperation="contains"

                    >
                        <RequiredRule />
                        <Lookup dataSource={brands} valueExpr="id" displayExpr="brand_name" />
                    </Column>
                    <Column
                        dataField="model_code"
                        caption={t("Model Kodu")}
                        alignment="center"
                        selectedFilterOperation="contains"
                    >
                        <RequiredRule />
                    </Column>
                    <Column
                        dataField="model_name"
                        caption={t("Model Adı")}
                        alignment="center"
                        selectedFilterOperation="contains"
                    >
                        <RequiredRule />
                    </Column>
                    <Column
                        //araç tipi binak, t,car, vs
                        dataField="vehicle_type"
                        caption={t("Araç Tipi")}
                        alignment="center"
                        selectedFilterOperation="contains"
                    >
                        <RequiredRule />
                        <Lookup dataSource={vehicleTypes} valueExpr="value" displayExpr="text" />
                    </Column>
                    <Column dataField="length_mm" caption={t("Uzunluk (mm)")} dataType="number" alignment="center">
                        <RangeRule min={1} message={t("Uzunluk sıfırdan büyük olmalıdır")} />
                    </Column>
                    <Column dataField="width_mm" caption={t("Genişlik (mm)")} dataType="number" alignment="center">
                        <RangeRule min={1} message={t("Genişlik sıfırdan büyük olmalıdır")} />
                    </Column>
                    <Column dataField="height_mm" caption={t("Yükseklik (mm)")} dataType="number" alignment="center">
                        <RangeRule min={1} message={t("Yükseklik sıfırdan büyük olmalıdır")} />
                    </Column>
                    <Column dataField="weight_kg" caption={t("Ağırlık (kg)")} dataType="number" alignment="center">
                        <RangeRule min={1} message={t("Ağırlık sıfırdan büyük olmalıdır")} />
                    </Column>
                    <Column
                        dataField="dimension_source"
                        caption={t("Ölçü veri kaynağı")}
                        alignment="center"
                        selectedFilterOperation="contains"
                    />
                    <Column
                        dataField="is_active"
                        caption={t("Geçerli")}
                        alignment="center"
                        selectedFilterOperation="contains"
                        dataType="boolean"

                    >

                    </Column>
                    <Toolbar>
                        <Item name="groupPanel" location="before" />
                        <Item location="after">
                            <RxButton
                                color="light"
                                outline
                                style={{
                                    paddingInline: "10px",
                                    border: "1px solid #ddd",
                                }}
                                onClick={fetchModels}
                            >
                                <i className="fa fa-refresh"></i>
                            </RxButton>
                        </Item>
                        <Item name="addRowButton" location="after" />
                        <Item location="after">
                            <RxButton
                                color="success"
                                style={{ paddingInline: "10px", color: "white" }}
                                onClick={(e) => ButtonOnExporting(
                                    e,
                                    ref,
                                    "Model Tanımları",
                                    "Sayfa-1"
                                )}
                            >
                                <i className="fa fa-file-excel-o"></i>
                            </RxButton>
                        </Item>
                    </Toolbar>
                </DatagridCustom>
            </Card>
        </>
    );
};

export default AracModelleri;
